import { useState } from 'react'
import { Inbox, Car, Users, Plus } from 'lucide-react'
import { cars, brl, STATUS } from '../data.js'

const pillCls = {
  enviada: 'bg-blue-100 text-blue-700',
  'em análise': 'bg-amber-100 text-amber-700',
  contatado: 'bg-violet-100 text-violet-700',
  aprovada: 'bg-brand-50 text-brand-700',
  recusada: 'bg-red-100 text-red-600',
  vendido: 'bg-slate-200 text-slate-600',
}

const fila = [
  { data: '09/08', tipo: 'Comprador', nome: 'Ana Souza', alvo: 'Hyundai Creta · 48x R$ 2.190', status: 'em análise' },
  { data: '09/08', tipo: 'Investidor · dinheiro', nome: 'Marcos Lima', alvo: 'R$ 80.000', status: 'enviada' },
  { data: '08/08', tipo: 'Comprador', nome: 'João Pedro Alves', alvo: 'Range Rover Evoque · 36x R$ 3.390', status: 'contatado' },
  { data: '07/08', tipo: 'Investidor · carro', nome: 'Cláudia Nunes', alvo: 'Fiat Toro 2021 · sugestão R$ 105.000', status: 'em análise' },
  { data: '05/08', tipo: 'Comprador', nome: 'Rafael Santos', alvo: 'Chevrolet Cruze · 60x R$ 1.690', status: 'aprovada' },
  { data: '01/08', tipo: 'Comprador', nome: 'Carlos Menezes', alvo: 'Toyota Corolla · 48x R$ 1.690', status: 'vendido' },
]

const leads = [
  { nome: 'Fernanda Costa', zap: '(11) 98888-1234', vistos: 'Creta, Golf', status: 'A contatar' },
  { nome: 'Diego Martins', zap: '(21) 97777-9876', vistos: 'Evoque', status: 'Contatado' },
  { nome: 'Patrícia Ramos', zap: '(31) 96666-4567', vistos: 'Golf, Cruze', status: 'A contatar' },
]

const tabs = [
  { id: 'fila', label: 'Fila de análise', icon: Inbox },
  { id: 'carros', label: 'Carros', icon: Car },
  { id: 'leads', label: 'Leads', icon: Users },
]

export default function Admin() {
  const [tab, setTab] = useState('fila')

  return (
    <main className="min-h-[70vh] bg-slate-100 pb-10 md:pb-16">
      <div className="bg-slate-900 py-4 text-white md:py-6">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4">
          <div>
            <div className="font-display text-xl font-bold">Painel Sim</div>
            <div className="text-sm text-slate-400">Gestão de carros, análises e leads</div>
          </div>
          <span className="hidden rounded-full bg-slate-700 px-3 py-1 text-xs sm:inline-block">admin@simcarros.com.br</span>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4">
        <div className="flex gap-1 overflow-x-auto pt-3 md:pt-4">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`inline-flex shrink-0 items-center gap-2 rounded-t-xl px-3 py-2 text-xs font-semibold transition md:px-4 md:py-2.5 md:text-sm ${
                tab === id ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'
              }`}
            >
              <Icon size={16} /> {label}
            </button>
          ))}
        </div>

        <div className="rounded-2xl rounded-tl-none bg-white p-3 shadow-sm md:p-6">
          {tab === 'fila' && (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[640px] text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
                    <th className="pb-3 pr-4">Data</th>
                    <th className="pb-3 pr-4">Tipo</th>
                    <th className="pb-3 pr-4">Nome</th>
                    <th className="pb-3 pr-4">Carro / valor</th>
                    <th className="pb-3 pr-4">Status</th>
                    <th className="pb-3" />
                  </tr>
                </thead>
                <tbody>
                  {fila.map((r) => (
                    <tr key={r.nome} className="border-b border-slate-100">
                      <td className="py-3 pr-4 text-slate-500">{r.data}</td>
                      <td className="py-3 pr-4">{r.tipo}</td>
                      <td className="py-3 pr-4 font-semibold text-slate-800">{r.nome}</td>
                      <td className="py-3 pr-4 text-slate-500">{r.alvo}</td>
                      <td className="py-3 pr-4"><span className={`rounded-full px-3 py-1 text-xs font-semibold ${pillCls[r.status]}`}>{r.status}</span></td>
                      <td className="py-3 text-right"><button className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 hover:border-slate-300">Ver</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {tab === 'carros' && (
            <>
              <div className="mb-4 flex justify-end">
                <button className="inline-flex items-center gap-2 rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700">
                  <Plus size={16} /> Cadastrar carro
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full min-w-[640px] text-sm">
                  <thead>
                    <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
                      <th className="pb-3 pr-4">Carro</th>
                      <th className="pb-3 pr-4">Origem</th>
                      <th className="pb-3 pr-4">FIPE</th>
                      <th className="pb-3 pr-4">Propostas</th>
                      <th className="pb-3 pr-4">Status</th>
                      <th className="pb-3" />
                    </tr>
                  </thead>
                  <tbody>
                    {cars.map((c) => (
                      <tr key={c.id} className="border-b border-slate-100">
                        <td className="py-3 pr-4">
                          <div className="flex items-center gap-3">
                            <img src={c.fotos[0]} alt="" className="h-10 w-14 rounded-lg object-cover" />
                            <div>
                              <div className="font-semibold text-slate-800">{c.nome}</div>
                              <div className="text-xs text-slate-400">{c.ano}</div>
                            </div>
                          </div>
                        </td>
                        <td className="py-3 pr-4 text-slate-500">{c.consignado ? 'Consignado' : 'Frota Sim'}</td>
                        <td className="py-3 pr-4 text-slate-500">{brl(c.fipe)}</td>
                        <td className="py-3 pr-4">{c.propostas}</td>
                        <td className="py-3 pr-4"><span className={`rounded-full px-3 py-1 text-xs font-semibold ${STATUS[c.status].cls}`}>{STATUS[c.status].label}</span></td>
                        <td className="py-3 text-right"><button className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 hover:border-slate-300">Editar</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {tab === 'leads' && (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[560px] text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
                    <th className="pb-3 pr-4">Nome</th>
                    <th className="pb-3 pr-4">WhatsApp</th>
                    <th className="pb-3 pr-4">Carros vistos</th>
                    <th className="pb-3 pr-4">Status</th>
                    <th className="pb-3" />
                  </tr>
                </thead>
                <tbody>
                  {leads.map((l) => (
                    <tr key={l.nome} className="border-b border-slate-100">
                      <td className="py-3 pr-4 font-semibold text-slate-800">{l.nome}</td>
                      <td className="py-3 pr-4 text-slate-500">{l.zap}</td>
                      <td className="py-3 pr-4 text-slate-500">{l.vistos}</td>
                      <td className="py-3 pr-4">
                        <span className={`rounded-full px-3 py-1 text-xs font-semibold ${l.status === 'Contatado' ? 'bg-brand-50 text-brand-700' : 'bg-amber-100 text-amber-700'}`}>{l.status}</span>
                      </td>
                      <td className="py-3 text-right"><button className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 hover:border-slate-300">Abrir WhatsApp</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </main>
  )
}
